export default __webpack_public_path__ + "static/media/paper-mill.dfeed839.svg";